import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClientService } from '../common/http-client.service';

import { AutocompleteResult } from '../../models/autocomplete-result';

@Injectable()
export class DocumentTypeSearchService {
  private documentTypesFieldSearchURL = 'document_types/field_search';

  private documentTypesURL = 'document_types';

  constructor(private httpClient: HttpClientService) {}

  documentTypesFieldSearch(term: string): Observable<AutocompleteResult[]> {
    return this.httpClient.getObservable(`${this.documentTypesFieldSearchURL}.json?term=${term}&typeahead=true`).pipe(map((response) => response as AutocompleteResult[]));
  }

  getDocumentTypeInfo(id: number): Promise<any> {
    return this.httpClient.get(`${this.documentTypesURL}/${id}.json`, {
      get_document_type: true,
    });
  }
}
